import { z } from "zod";
export const alarmCriticalitySchema = z.enum(["Critical", "Non critical", "Warning"]);
export const alarmStatusSchema = z.enum(["Active", "Deactivated"]);
export const predictiveMaintenanceInsightDtoSchema = z.object({
    alarmId: z.string(),
    date: z.string(),
    alarmStartDate: z.string(),
    deviceSerialNumber: z.string(),
    deviceType: z.string().nullable(),
    LDN: z.number().nullable(),
    farmLicenseKey: z.string().nullable(),
    customerNumber: z.string().nullable(),
    customerName: z.string().nullable(),
    serviceAreaId: z.string().nullable(),
    serviceAreaName: z.string().nullable(),
    lelyCenterNumber: z.string().nullable(),
    lelyCenterName: z.string().nullable(),
    alarmName: z.string().nullable(),
    alarmCriticality: alarmCriticalitySchema.nullable(),
    alarmStatus: alarmStatusSchema.nullable(),
    alarmDescription: z.string().nullable(),
    visitDate: z.string().nullable(),
    feedbackVersion: z.string().nullable(),
    feedbackStructure: z
        .object({
        form: z.object({
            question1: z
                .object({
                label: z.string(),
                options: z.array(z.string()),
            })
                .nullable(),
            question2: z
                .object({
                label: z.string(),
                options: z.array(z.string()),
            })
                .nullable(),
            question3: z
                .object({
                label: z.string(),
                options: z.array(z.string()),
            })
                .nullable(),
            question4: z
                .object({
                label: z.string(),
            })
                .nullable(),
        }),
    })
        .nullable(),
});
//# sourceMappingURL=predictive-maintenance.schema.js.map